<template>
    <div :class="['badge', 'executive-badge', size]" v-if="linked">
        <div class="avatar-container">
            <router-link :to="to">
                <ExecutiveAvatar :executive="executive" :size="size" />
            </router-link>
        </div>

        <div class="title">
            <router-link class="primary-link" :to="to" v-popover:executive="hidePopover ? undefined : executive">
                {{ executive.colloquialName }}
            </router-link>
            <CeoChangeLogo
                v-if="executive.ceoChangeReportAvailableForEntity"
                :class="`verified inline ${ceoChangeLogoSize}`"
            />
        </div>

        <div class="subtitle">
            <CompanyLink v-if="!hideCompany" type="tertiary-link" :company="executive.currentCompany" />
            <span v-if="showPosition">
                <template v-if="!hideCompany && executive.currentCompany"> - </template>
                {{ executive.position }}
            </span>
        </div>
    </div>
    <div :class="['badge', 'executive-badge', size]" v-else>
        <div class="avatar-container">
            <ExecutiveAvatar :executive="executive" :size="size" />
        </div>

        <div class="title">
            {{ executive.colloquialName }}
        </div>

        <div class="subtitle">
            <CompanyLink
                v-if="!hideCompany"
                type="tertiary-link"
                :company="executive.currentCompany"
                :hidePopver="hidePopover"
            />
            <span v-if="showPosition">
                <template v-if="!hideCompany && executive.currentCompany"> - </template>
                {{ executive.position }}
            </span>
        </div>
    </div>
</template>
<script>
import CeoChangeLogo from '@/components/ceo-change/logo'
import CompanyLink from '@/components/companies/CompanyLink'
import ExecutiveAvatar from '@/components/executives/avatar'

export default {
    name: 'ExecutiveBadge',

    components: {
        CeoChangeLogo,
        CompanyLink,
        ExecutiveAvatar,
    },

    props: {
        executive: {
            type: Object,
            required: true,
        },
        // Shown by default
        hideCompany: {
            type: Boolean,
            default: false,
        },
        hidePopover: {
            type: Boolean,
            default: false,
        },
        link: {
            type: [String, Object],
            default: null,
        },
        query: {
            type: Object,
            default: null,
        },
        // Hidden by default
        showPosition: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'small',
        },
    },
    computed: {
        ceoChangeLogoSize() {
            return this.size === 'medium' ? 'md' : 'xs'
        },
        linked() {
            return this.executive.id > 0 || this.executive.trackedSince
        },
        to() {
            return (
                this.link ?? {
                    name: 'executive-page',
                    params: { id: this.executive?.id },
                    query: this.query,
                }
            )
        },
    },
}
</script>
